module.exports = __webpack_public_path__ + "img/wqcl2.c843331f.png";